import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../redux/store';
import { fetchUserData } from '../../redux/authSlice';
import { Button, Typography, Box, Avatar } from '@mui/material';

const VerificationOverview: React.FC = () => {
  const { userId: paramUserId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const authUser = useSelector((state: RootState) => state.auth.user);
  const userId = paramUserId || authUser?.uid;

;

  const profilePicture = authUser?.profilePicture;
  const lastInitial = authUser?.lastName?.charAt(0)?.toUpperCase() || '?';

  const handleRedirect = (path: string) => {
    if (!userId) return;
    navigate(`/${path}/${userId}`);
  };

  return (
    <Box sx={styles.container}>
      <div style={styles.avatarWrapper}>
        <div style={styles.gradientRing}>
          {profilePicture ? (
            <img src={profilePicture} alt="avatar" style={styles.avatarImage} />
          ) : (
            <Avatar sx={{ ...styles.avatarImage, backgroundColor: '#741F4C', fontSize: 32 }}>
              {lastInitial}
            </Avatar>
          )}
        </div>
      </div>

      <Typography variant="h6" sx={styles.title}>
        Complete Verification
      </Typography>

      <Box sx={styles.gradientWrapper}>
        <Button fullWidth onClick={() => handleRedirect('verifyemail')} sx={styles.button}>
          Verify Email
        </Button>
      </Box>

      <Box sx={styles.gradientWrapper}>
        <Button fullWidth onClick={() => handleRedirect('verifyphone')} sx={styles.button}>
          Verify Phone
        </Button>
      </Box>

      <Box sx={styles.gradientWrapper}>
        <Button fullWidth onClick={() => handleRedirect('verifyidentity')} sx={styles.button}>
          Verify Identity
        </Button>
      </Box>
    </Box>
  );
};

export default VerificationOverview;

const styles: { [key: string]: any } = {
  container: {
    p: 4,
    maxWidth: 400,
    margin: 'auto',
    minHeight: '100vh',
    background: '#fff',
    color: '#000',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatarWrapper: {
    position: 'relative',
    width: 130,
    height: 130,
    margin: '0 auto 20px',
  },
  gradientRing: {
    width: 130,
    height: 130,
    borderRadius: '50%',
    background: 'linear-gradient(180deg, #D7262C 0%, #741F4C 50%, #0A1C3F 100%)',
    padding: 5,
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontWeight: 600,
  },
  title: {
    fontWeight: 600,
    mb: 4,
  },
  gradientWrapper: {
    mb: 2,
    background: 'linear-gradient(180deg, #D7262C 0%, #741F4C 50%, #0A1C3F 100%)',
    borderRadius: 2,
    padding: '2px',
  },
  button: {
    backgroundColor: '#fff',
    color: '#000',
    fontWeight: 600,
    fontSize: 16,
    borderRadius: 2,
    textTransform: 'none',
    py: 1.5,
    transition: 'all 0.3s ease',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#f2f2f2',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      color: '#000',
    },
  },
};
